import PackingType from "./PackingType.js";
import SystemRight from "./SystemRight.js";
import HttpClient from "./HttpClient.js";
export default class Company{
    constructor(company){
        this.id = company.id;
        this.name = company.name;
        this.code = company.code;
        this.created_at = company.created_at;
        this.updated_at = company.updated_at;
        this.pallet_count = company.pallet_count;
        this.pallet_count_year = company.pallet_count_year;
        this.allow_custom_pallets = company.allow_custom_pallets;
        this.pref_packing_type = company.pref_packing_type;
        this.default_pallet_list_template = company.default_pallet_list_template;
        this.default_truck_list_template = company.default_truck_list_template;
        this.truck_loaded_email_template = company.truck_loaded_email_template;
        this.manager_emails = company.manager_emails;
        this.packing_types = this.getPackingTypes(company.packing_types);
        this.system_rights = this.getSystemRights(company.system_rights);
        this.default_truck_spacing = company.default_truck_spacing;
    }

    async save(data){
        const client = new HttpClient();
        const response = client.instance.put(`companies`, data);
        return response.data
    }

    getPackingTypes(packingTypes){
        let packingTypesObj = [];
        packingTypes.forEach(packingType => {
            packingTypesObj.push(new PackingType(packingType));
        });
        return packingTypesObj;
    }

    getSystemRights(systemRights){
        let systemRightsObj = [];
        systemRights.forEach(systemRight => {
            systemRightsObj.push(new SystemRight(systemRight));
        });
        return systemRightsObj;
    }
}